import type { FieldComponent } from '@atlas/react-forms';
import cx from 'classnames';
import { type ChangeEvent, type MouseEvent, useState } from 'react';

import Errors from 'components/Form/Errors';
import { TranslationWithLinks } from 'utils/translations';

import styles from './CheckboxField.module.scss';

const Checkbox: FieldComponent = ({ field, onFocus, onBlur, onChange }) => {
  const [showError, setShowError] = useState(false);

  const handleChangeValue = (e: ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.checked, true);
  };

  const handleBlur = () => {
    onBlur?.();
    setShowError(true);
  };

  const handleFocus = () => {
    onFocus?.();
    setShowError(false);
  };

  const handleMouseDown = (e: MouseEvent<HTMLLabelElement>) => {
    e.preventDefault();
  };

  return (
    <div
      className={cx(styles['form-checkbox-container'], {
        [styles['with-error']]: showError && field.errors.length > 0,
      })}
    >
      <label
        className={cx(styles.checkbox, {
          [styles['with-label']]: !!field.label,
        })}
        onMouseDown={handleMouseDown}
      >
        <input
          type="checkbox"
          onChange={handleChangeValue}
          name={field.name}
          id={field.name}
          checked={!!field.value}
          onBlur={handleBlur}
          onFocus={handleFocus}
        />
        <TranslationWithLinks message={field.label} />
      </label>
      {showError && <Errors errors={field.errors} />}
    </div>
  );
};

export default Checkbox;
